import { createAction, props } from '@ngrx/store';
import { InverterV2, VirtualRTStateType } from 'ngx-core-services';

export const activateRealTimeTelemetry = createAction(
  '[RealTime] Activate Real-Time Telemetry',
  props<{ plantId: string; systemId: string; emsId: string; monitoringType: 'AzzurroHub' | 'Connext'; duration?: number }>()
);

export const realTimeTelemetryActivated = createAction(
  '[RealTime] Real-Time Telemetry Activated',
  props<{ systemId: string; startTS: number; duration: number }>()
);

export const realTimeTelemetryDataReceived = createAction(
  '[RealTime] Real-Time Telemetry Data Received',
  props<{ systemId: string; data: InverterV2 }>()
);

export const realTimeTelemetrySessionEnded = createAction(
  '[RealTime] Real-Time Telemetry Session Ended',
  props<{ systemId: string; endedAt: number }>()
);

export const setRealTimeTelemetryOverlayHidden = createAction(
  '[RealTime] Set Real-Time Overlay Hidden',
  props<{ systemId: string; hidden: boolean }>()
);

export const realTimeTelemetryActivationFailed = createAction(
  '[RealTime] Real-Time Telemetry Activation Failed',
  props<{ systemId: string; error: string }>()
);

export const realTimeTelemetryDeactivationFailed = createAction(
  '[RealTime] Real-Time Telemetry Deactivation Failed',
  props<{ systemId: string; error: string }>()
);

export const deactivateRealTimeTelemetry = createAction(
  '[RealTime] Deactivate Real-Time Telemetry',
  props<{ plantId: string; systemId: string; emsId: string; monitoringType: 'AzzurroHub' | 'Connext' }>()
);

export const resumeRealTimeTelemetry = createAction(
  '[RealTime] Resume Real-Time Telemetry',
  props<{ plantId: string; systemId: string; emsId: string; monitoringType: 'AzzurroHub' | 'Connext'; virtualRTStatus: VirtualRTStateType }>()
);
